import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';

const RuleItem = styled.div<{ $isWhiteIcon: boolean; $hasInfoIcon: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hasInfoIcon }) => ($hasInfoIcon ? '24px 1fr 20px' : '24px 1fr ')};
  gap: 8px;
  & > svg:nth-of-type(1) > path:nth-of-type(1) {
    fill: ${({ $isWhiteIcon }) => $isWhiteIcon && color(COLOR_VARIANTS.WHITE)};
  }
`;

export default {
  RuleItem,
};
